import React from "react";

import Button from "core/Button";
import Flexbox from "core/Flexbox";

import { PhotoUploadFooterSectionContainer } from "../PhotoUploadFooter/styles";

const PhotoUploadTypeSelectFooter = ({ handleSubmit }) => (
    <PhotoUploadFooterSectionContainer>
        <Flexbox justifyContent="flex-end">
            <Button onClick={handleSubmit}>Continue to Upload</Button>
        </Flexbox>
    </PhotoUploadFooterSectionContainer>
);

export default PhotoUploadTypeSelectFooter;
